import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectDisasterAssistanceHardshipStep = (state) => state.get('disasterAssistanceHardshipStep');

const makeSelectDisasterAssistanceHardshipStep = () => createSelector(
  selectDisasterAssistanceHardshipStep,
  (stepDisasterAssistanceHardshipState) => ({
    employerName: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'employerName']),
      ''
    ),
    employerEmail: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'employerEmail']),
      ''
    ),
    address1: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'address1']),
      ''
    ),
    address2: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'address2']),
      ''
    ),
    city: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'city']),
      ''
    ),
    state: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'state']),
      ''
    ),
    province: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'province']),
      ''
    ),
    country: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'country']),
      ''
    ),
    zipOrPostalCode: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'zipOrPostalCode']),
      ''
    ),
    nameOfYourHomeownersRentersInsuranceCarrier: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'nameOfYourHomeownersRentersInsuranceCarrier']),
      ''
    ),
    carrierPhoneNumber: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'carrierPhoneNumber']),
      ''
    ),
    carrierEmail: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'carrierEmail']),
      ''
    ),
    address1Carrier: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'address1Carrier']),
      ''
    ),
    address2Carrier: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'address2Carrier']),
      ''
    ),
    cityCarrier: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'cityCarrier']),
      ''
    ),
    stateCarrier: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'stateCarrier']),
      ''
    ),
    provinceCarrier: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'provinceCarrier']),
      ''
    ),
    countryCarrier: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'countryCarrier']),
      ''
    ),
    zipOrPostalCodeCarrier: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'zipOrPostalCodeCarrier']),
      ''
    ),
    yourHomeownersRentersPolicyNumber: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'yourHomeownersRentersPolicyNumber']),
      ''
    ),
    dateTheDisasterOccurred: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'dateTheDisasterOccurred']),
      ''
    ),
    yourClaimNumberWithYourCarrier: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'yourClaimNumberWithYourCarrier']),
      ''
    ),
    isYourDamageOrLossOver10000: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'isYourDamageOrLossOver10000']),
      ''
    ),
    didTheDisasterCauseDamageToYourPrimaryResidence: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'didTheDisasterCauseDamageToYourPrimaryResidence']),
      ''
    ),
    didYouReportTheDisasterEvent: mapWithDefault(
      stepDisasterAssistanceHardshipState,
      () => stepDisasterAssistanceHardshipState.getIn(['form', 'didYouReportTheDisasterEvent']),
      ''
    ),
  })
);

const makeSelectDisasterAssistanceHardshipStepErrors = () =>
  createSelector(selectDisasterAssistanceHardshipStep, (state) => state.get('errors'));

export {
  makeSelectDisasterAssistanceHardshipStep,
  makeSelectDisasterAssistanceHardshipStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.DuesProtect.DisasterAssistanceHardshipStep/selectors.js